var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    _vm._l(_vm.parts, function(part, index) {
      return _c(
        "span",
        { key: index },
        [
          part.isStrong
            ? _c("strong", [_vm._v(_vm._s(part.text))])
            : part.diff
            ? _c("ChangeLogPreviewBtn", {
                attrs: { diff: part.diff, wide: _vm.wide }
              })
            : [_vm._v(_vm._s(part.text))]
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }